import { notification } from 'antd'

export const SuccessToastLifeTime = {
  Short: 3,
  Long: 6,
  OneDay: 86400,
} as const

export function useSuccessHandler() {
  const addSuccessToast = (onClose?: () => void, lifeTime?: number) => {
    const duration = lifeTime ?? SuccessToastLifeTime.Short

    notification.success({
      title: 'Done',
      description: 'Success!',
      duration,
      onClose,
      placement: 'bottomRight',
    })
  }

  return { addSuccessToast }
}
